// @flow

import styled from 'styled-components';
import type { Theme } from '../../../../../../types';
import { SEMIBOLD } from '../../../../../../helpers/fontWeight';
import Price from '../../../../../price';

type Props = {
  type: string;
};

export const GroupItemContent = styled<any, Theme>('section')`
  max-width: 80%;
`;

export const GroupItemTitle = styled<any, Theme>('section')`
  color: ${props => props.theme.cart.titleColor};
  font-weight: ${SEMIBOLD};
`;

export const GroupItemText = styled<any, Theme, Props>('section')`
  white-space: ${props => (props.type ? 'nowrap' : 'initial')};
`;

export const GroupItemPrice = styled<typeof Price, Theme, _>(Price)`
  font-weight: ${SEMIBOLD};
`;

export default null;
